import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/talker/mutations'
import { path } from '@/store/talker/types'
import { mutation } from '@/utils/mutation'
import state, { ITalkerState } from '@/store/talker/state'

export * from '@/store/talker/state'

export const store: Module<ITalkerState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
